import { render, staticRenderFns } from "./ShowAcc.vue?vue&type=template&id=6c5c511e&scoped=true&"
import script from "./ShowAcc.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShowAcc.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ShowAcc.vue?vue&type=style&index=0&id=6c5c511e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c511e",
  null
  
)

export default component.exports